<template>
  <div class="row pt-2">
    <div class="col">
      <div v-if="isSauvegardeEnCours">
        <vue-loaders  name="ball-beat" class = "justify-center"></vue-loaders>
      </div>
      <div v-else>
        <Button label="Ajouter" @click="ajouter" />
      </div>
    </div>
    <div class="col">
      <Button label="Fermer" @click="fermer"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonBar',
  emits: ['ajouter', 'fermer'],
  props: ['isSauvegardeEnCours'],
  methods: {
    ajouter() {      
      this.$emit('ajouter');
    },
    fermer() {
      this.$emit('fermer');
    },
  }
}
</script>